import { FC, useEffect } from "react"
import { useParams } from "react-router-dom"
import { useStore } from "stores/utils/use-store"
import { observer } from "mobx-react"
import { Switch, Table, Tag } from "antd"
import { defaultFormat } from "utils/date"

export const AccountInstalledPackages: FC = observer<FC>(() => {
  const { id } = useParams<{ id: string }>()

  const { dataStore: { accountTrackingStore } } = useStore()

  useEffect(() => {
    if (!id) {
      return
    }

    accountTrackingStore.getInstalledPackages(id)
  }, [accountTrackingStore, id])

  return (
    <Table
      dataSource={accountTrackingStore?.accountInstalledPackages || []}
      columns={[
        {
          title: "Package Name",
          dataIndex: "platformId",
        },
        {
          title: "First seen at",
          dataIndex: "createdAt",
          render: (el: Date) => el && <Tag color="green">{defaultFormat(el)}</Tag>,
        },
        {
          title: "Active (filtered out of recommended games)",
          dataIndex: "active",
          render: (el, record) => (
            <Switch
              checked={el}
              onChange={active => accountTrackingStore.updateInstalledPackage(record.accountId, record.platformId, active)}
            />
          ),
        },
      ]}
      rowKey="packageName"
      pagination={false}
      loading={accountTrackingStore.isLoading}
    />
  )
})
